<template>
    <div v-if="showHighlightsAndNotes" dusk="ReaderNoteAndHighlight" class="flex flex-1 flex-col overflow-hidden">
        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <div
                v-if="highlightsAndNotesListIsEmpty"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noHighlightsAndNotes }}
                </p>
            </div>
            <div
                v-else-if="highlightsAndNotesList.length === 0"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noFilterHighlightsAndNotesColor }}
                </p>
            </div>
            <HighlightAndNotesText v-else :highlights="highlightsAndNotesList" />
        </div>
        <ExportNotesOrHighlight :disable-export="true" @checked-colors="colors => (checkedColors = colors)" />
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import HighlightAndNotesText from '../partials/HighlightAndNotesText.vue';
import ExportNotesOrHighlight from '../partials/ExportNotesOrHighlight.vue';

export default {
    components: {
        HighlightAndNotesText,
        ExportNotesOrHighlight,
    },
    data() {
        return {
            checkedColors: [],
        };
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'selections']),
        ...mapGetters(['showHighlightsAndNotes', 'highlightColorsCode']),

        highlightsAndNotesList() {
            return this.selections.filter(selection => this.checkedColors.includes(selection.color));
        },

        highlightsAndNotesListIsEmpty() {
            return this.selections.length === 0;
        },
    },
    mounted() {
        this.checkedColors = this.highlightColorsCode;
    },
};
</script>
